module.exports = __webpack_public_path__ + "static/media/email.d258bf2b.png";